module.exports = __webpack_public_path__ + "img/reset-password-v2.efbce9cb.svg";